import { QRCodeSVG } from "qrcode.react";
import { Printer } from "lucide-react";

export function VehicleQR({ vehicle }) {
  const url = `${window.location.origin}/vehicles/${vehicle.id}`;
  const print = () => {
    const w = window.open("", "_blank", "width=420,height=560");
    const svg = document.getElementById(`qr-${vehicle.id}`)?.outerHTML || "";
    w.document.write(`<html><head><title>${vehicle.registration_no}</title></head><body style="font-family:system-ui;text-align:center;padding:24px">${svg}<h1 style="margin:16px 0 4px;font-size:28px">${vehicle.registration_no}</h1><p style="color:#6C6C70;margin:0">${vehicle.make} ${vehicle.model} · Insideman's Garage</p><p style="font-size:12px;color:#6C6C70">Scan to record odometer or report an issue</p><script>window.onload=()=>window.print()</script></body></html>`);
    w.document.close();
  };
  return (
    <div className="fv-card flex flex-col items-center gap-3 p-5" data-testid="vehicle-qr">
      <QRCodeSVG id={`qr-${vehicle.id}`} value={url} size={168} level="M" includeMargin />
      <p className="text-center text-xs text-muted-foreground">Stick this on the vehicle. Scanning opens this page for odometer and issue entry.</p>
      <button onClick={print} data-testid="print-qr-btn" className="flex h-9 items-center gap-1 rounded-full border px-3 text-sm font-medium text-primary hover:bg-primary/10"><Printer className="h-4 w-4" />Print label</button>
    </div>
  );
}
